export default {
      id: "oc-daping-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-daping",
      toString: function () {
        return this.url;
      }
    }